import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface ProgressiveDisclosureProps {
  children: React.ReactNode;
  previewLines?: number;
  className?: string;
}

const ProgressiveDisclosure: React.FC<ProgressiveDisclosureProps> = ({
  children,
  previewLines = 3,
  className = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={`relative ${className}`}>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          !isExpanded ? `line-clamp-${previewLines}` : ''
        }`}
        style={!isExpanded ? { maxHeight: `${previewLines * 1.5}rem` } : undefined}
      >
        {children}
      </div>
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="mt-2 flex items-center gap-1 text-blue-600 hover:text-blue-700 transition-colors text-sm font-medium min-h-[44px] px-3 py-2"
      >
        {isExpanded ? (
          <>
            <ChevronUpIcon className="w-4 h-4" />
            {t('common.readLess', 'Read Less')}
          </>
        ) : (
          <>
            <ChevronDownIcon className="w-4 h-4" />
            {t('common.readMore', 'Read More')}
          </>
        )}
      </button>
    </div>
  );
};

export default ProgressiveDisclosure;
